import styled from '@emotion/styled';

export const RefreshCounterWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
`;

export const RefreshCounterMessage = styled.span`
  font-size: var(--font-size-small);
  color: var(--color-core-primary);
  margin-left: var(--gutter-tiny);
`;

export const WarningDescription = styled.p`
  color: var(--color-buttons-delete-active);
`;

export const InfoText = styled.p`
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-thin);
  margin-top: var(--gutter);
`;
